import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { graphql, Link } from "gatsby";
import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";

// eslint-disable-next-line
export const OurSchoolPostTemplate = ({
  content,
  contentComponent,
  description,
  tags,
  title,
  helmet,
}) => {
  const PostContent = contentComponent || Content;

  return (
    <section className="section">
      {helmet || ""}
      <div className="container content">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div style={{marginTop: "0rem", marginBottom: "-1rem"}}>
              <small><em><Link to="/">Home</Link> &#10230; <Link to="/our-school">Our School</Link> &#10534;</em></small>
            </div>
            <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
              {title}
            </h1>
            <p>{description}</p>
            <PostContent content={content} />
            <div style={{marginTop: "3rem"}}>
              <small>You are here: <em><Link to="/">Home</Link> &#10230; <Link to="/our-school">Our School</Link> &#10230; {title}</em></small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

OurSchoolPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
};

const OurSchoolPost = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout 
      pageTitle={post.frontmatter.title} 
      pageDescription={post.frontmatter.description}
      pageSlug={post.fields.slug}
      pageImage={post.frontmatter.featuredimage ? post.frontmatter.featuredimage.childImageSharp.gatsbyImageData.images.fallback.src : null}
    >
      <OurSchoolPostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        helmet={
          <Helmet titleTemplate="%s | Our School">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
      />
    </Layout>
  );
};

OurSchoolPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default OurSchoolPost;

export const pageQuery = graphql`
  query OurSchoolPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        featuredimage {
          childImageSharp {
            gatsbyImageData(width: 400, quality: 64, layout: CONSTRAINED)
          }
        }
        date(formatString: "MMMM DD, YYYY")
        title
        description
        tags
      }
    }
  }
`;
